import { NavIcon, type NavIconName } from "../nav/NavIcon";

/**
 * G-9.2 kit: filter chip — selected state is the accent-soft fill (full accent
 * fill stays reserved for primary buttons). Use SegmentedControl when exactly
 * one option must always be selected. `count` shows a small number after the
 * label; `icon` a glyph before it (G-132 inventory chips).
 */
export function Chip({
  label,
  selected,
  onClick,
  disabled = false,
  count,
  icon,
}: {
  label: string;
  selected: boolean;
  onClick: () => void;
  disabled?: boolean;
  count?: number;
  icon?: NavIconName;
}) {
  return (
    <button
      type="button"
      className={selected ? "kit-chip is-selected" : "kit-chip"}
      aria-pressed={selected}
      onClick={onClick}
      disabled={disabled}
    >
      {icon ? <NavIcon name={icon} size={14} /> : null}
      {label}
      {count !== undefined ? <span className="kit-chip-count">{count}</span> : null}
    </button>
  );
}
